import { parse } from 'date-fns';

const toTaipeiISODate = (d) => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit'
}).format(d);

export const toTaipeiMDYDate = (d) => new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit'
}).format(d).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1-$2-$3');

export const normalizeToISODateTaipei = (input) => {
  if (!input) return { ok: false, error: 'Missing date value' };
  try {
    let d;
    if (input instanceof Date) {
      d = input;
    } else if (typeof input === 'string') {
      const s = input.trim();
      if (s.includes('+') || s.endsWith('Z')) {
        d = new Date(s);
      } else {
        const formats = ['MM-dd-yyyy', 'MM/dd/yyyy', 'yyyy-MM-dd', 'yyyy/MM/dd', 'MMM dd, yyyy'];
        for (const fmt of formats) {
          const parsed = parse(s, fmt, new Date());
          if (!isNaN(parsed.getTime())) { d = parsed; break; }
        }
        if (!d) {
          const fallback = new Date(s);
          if (!isNaN(fallback.getTime())) d = fallback;
        }
      }
    } else {
      const fallback = new Date(input);
      if (!isNaN(fallback.getTime())) d = fallback;
    }
    if (!d || isNaN(d.getTime())) {
      return { ok: false, error: 'Unrecognized date format. Use MM-DD-YYYY or ISO 8601.' };
    }
    const iso = toTaipeiISODate(d);
    return { ok: true, value: iso };
  } catch (e) {
    return { ok: false, error: 'Failed to parse date. Use MM-DD-YYYY or ISO 8601.' };
  }
};

export const validateDateRangeTaipei = (start, end) => {
  const s = normalizeToISODateTaipei(start);
  const e = normalizeToISODateTaipei(end);
  const errors = [];
  if (!s.ok) errors.push('Start date: ' + s.error);
  if (!e.ok) errors.push('End date: ' + e.error);
  if (errors.length) return { ok: false, errors };
  if (s.value > e.value) return { ok: false, errors: ['Start date must be before or equal to end date'] };
  return { ok: true, startISO: s.value, endISO: e.value };
};

export default { normalizeToISODateTaipei, validateDateRangeTaipei, toTaipeiMDYDate };
